import "./nonce-init";
import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { FluentProvider, teamsLightTheme } from "@fluentui/react-components";
import { BrowserRouter } from "react-router-dom";
import { store, StoreContext } from "./stores/Stores";
import TranslationProvider from "./shared/translation/TranslationProvider";

const root = createRoot(document.getElementById("root")!);
root.render(
    <StoreContext.Provider value={store}>
        <TranslationProvider>
            <FluentProvider theme={teamsLightTheme}>
                <BrowserRouter>
                    <App />
                </BrowserRouter>
            </FluentProvider>
        </TranslationProvider>
    </StoreContext.Provider>
);
